<template>
  <el-dialog
    :title="mode === 'create' ? '新增培训资料' : '编辑培训资料'"
    :visible.sync="dialogVisible"
    width="1000px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="资料标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入资料标题" />
      </el-form-item>

      <el-form-item label="资料分类" prop="category">
        <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
          <el-option
            v-for="category in categoryOptions"
            :key="category.value"
            :label="category.label"
            :value="category.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="资料描述" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="请输入资料描述"
        />
      </el-form-item>

      <el-form-item label="预计时长" prop="estimatedDuration">
        <el-input-number
          v-model="form.estimatedDuration"
          :min="1"
          :max="999"
          placeholder="分钟"
          style="width: 200px"
        />
        <span style="margin-left: 10px; color: #909399">分钟</span>
      </el-form-item>

      <el-form-item label="资料文件" prop="files">
        <div class="file-upload-section">
          <el-button type="primary" @click="handleAddFile">
            <i class="el-icon-plus"></i>
            添加文件
          </el-button>

          <div v-if="form.files && form.files.length > 0" class="file-list">
            <div v-for="(file, index) in form.files" :key="index" class="file-item">
              <div class="file-info">
                <el-input
                  v-model="file.title"
                  size="small"
                  placeholder="文件主题"
                  @change="checkFiles"
                  style="width: 200px; margin-right: 10px"
                />
                <el-select
                  v-model="file.fileType"
                  size="small"
                  placeholder="文件类型"
                  style="width: 120px; margin-right: 10px"
                  @change="checkFiles"
                >
                  <el-option label="视频" value="VIDEO" />
                  <el-option label="文档" value="PDF" />
                  <el-option label="图文" value="IMAGE" />
                </el-select>

                <span class="file-size">{{ formatSize(file.totalSize) }}</span>

                <!-- 文件列表按钮 -->
                <span class="file-list-button">
                  <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-document"
                    @click="handleViewFiles(index)"
                    style="margin-left: 10px"
                  >
                    文件列表 ({{ (file.files && file.files.length) || 0 }})
                  </el-button>
                </span>
              </div>
              <div class="file-actions">
                <el-button size="mini" @click="handleUploadFile(index)">上传</el-button>
                <el-button size="mini" type="danger" @click="handleRemoveFile(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="启用状态" prop="enabled">
        <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="confirmLoading"> 确定 </el-button>
    </div>

    <!-- 文件上传对话框 -->
    <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" width="500px" append-to-body>
      <multiple-file-upload
        v-model="currentFiles"
        uploadTip="支持单个或多个文件上传，单个文件大小不超过20MB"
        :beforeUpload="handleBeforeUpload"
        :bucket="ossBucket"
        :filePath="ossFilePath"
        :limit="10"
      />

      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadConfirm">确定</el-button>
      </div>
    </el-dialog>
    <!-- 文件列表对话框 -->
    <el-dialog title="文件列表" :visible.sync="fileListDialogVisible" width="900px" append-to-body>
      <div v-if="currentFileList && currentFileList.length > 0">
        <el-table :data="currentFileList" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="文件名" min-width="200">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="previewFile(scope.row.url)"
                style="cursor: pointer"
              >
                <i class="el-icon-document"></i>
                {{ scope.row.name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="120" align="center">
            <template slot-scope="scope">
              <span>{{ formatSize(scope.row.size) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                plain
                @click="handleRemoveFileUrlInDialog(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else class="empty-tip">
        <el-empty description="暂无文件" :image-size="80"></el-empty>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileListDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 文件预览对话框 -->
    <el-dialog title="文件预览" :visible.sync="previewDialogVisible" width="720px" append-to-body>
      <file-preview v-if="previewUrl" :value="previewUrl" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { BaseDataService } from "@/service/base-data-service";
import FilePreview from "@/components/FilePreview";
import { OssUtil } from "@/util";

import { saveTrainingMaterials } from "@/api";

export default {
  name: "MaterialsDialog",
  components: {
    FilePreview
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "create" // create | edit
    }
  },
  data() {
    return {
      dialogVisible: false,
      confirmLoading: false,
      ossFilePath: "/new_training/material",
      ossBucket: "yxmgt-private",
      categoryOptions: BaseDataService.trainingCategoryOpts(),
      form: {
        title: "",
        category: "",
        description: "",
        estimatedDuration: null,
        files: [],
        enabled: true
      },

      rules: {
        title: [{ required: true, message: "请输入资料标题", trigger: "blur" }],
        category: [{ required: true, message: "请选择资料分类", trigger: "change" }],
        description: [{ required: true, message: "请输入资料描述", trigger: "blur" }],
        estimatedDuration: [{ required: true, message: "请输入预计时长", trigger: "blur" }],
        files: [
          {
            validator: this.validateFiles,
            trigger: "submit"
          }
        ]
      },

      // 文件上传相关
      uploadDialogVisible: false,
      currentFileIndex: -1,
      currentFiles: [],
      // 文件列表对话框
      fileListDialogVisible: false,
      currentFileList: [],
      currentFileListIndex: -1,
      // 预览相关
      previewDialogVisible: false,
      previewUrl: ""
    };
  },

  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { ...val };
        }
      },
      deep: true
    }
  },
  methods: {
    // 验证文件字段
    validateFiles(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请至少添加一个文件"));
        return;
      }
      for (let i = 0; i < value.length; i++) {
        const file = value[i];
        if (!file.title || file.title.trim() === "") {
          callback(new Error(`第 ${i + 1} 个文件的文件主题不能为空`));
          return;
        }
        if (!file.fileType) {
          callback(new Error(`第 ${i + 1} 个文件的文件类型不能为空`));
          return;
        }
        if (!file.files || file.files.length === 0) {
          callback(new Error(`第 ${i + 1} 个文件不能为空`));
          return;
        }
      }
      callback();
    },

    // 初始化表单
    initForm() {
      if (this.mode === "create") {
        this.form = {
          title: "",
          category: "",
          description: "",
          estimatedDuration: null,
          files: [],
          enabled: true
        };
      } else {
        this.form = { ...this.formData };
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    checkFiles() {
      this.$refs.form && this.$refs.form.validateField("files");
    },

    // 添加文件
    handleAddFile() {
      if (!this.form.files) {
        this.form.files = [];
      }

      this.form.files.push({
        title: "",
        fileType: "VIDEO",
        files: [],
        totalSize: 0
      });
    },

    // 移除文件
    handleRemoveFile(index) {
      // 先删除oss所有文件
      this.form.files[index].files.forEach((url) => {
        OssUtil.deleteFile(this.ossBucket, this.ossFilePath, url.url);
      });
      this.form.files.splice(index, 1);
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField("files");
      });
    },

    // 在对话框中移除文件URL
    handleRemoveFileUrlInDialog(urlIndex) {
      this.$confirm("确定要删除这个文件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (
            this.currentFileListIndex >= 0 &&
            this.form.files[this.currentFileListIndex] &&
            this.form.files[this.currentFileListIndex].files
          ) {
            OssUtil.deleteFile(
              this.ossBucket,
              this.ossFilePath,
              this.form.files[this.currentFileListIndex].files[urlIndex].url
            );
            this.form.files[this.currentFileListIndex].files.splice(urlIndex, 1);
            // 更新对话框中的列表
            this.currentFileList = this.form.files[this.currentFileListIndex].files || [];
            // 重新计算文件大小
            this.recalculateFileSize(this.currentFileListIndex);

            this.$message.success("删除成功");
          }
        })
        .catch(() => {});
    },

    // 查看文件列表
    handleViewFiles(fileIndex) {
      this.currentFileListIndex = fileIndex;
      this.currentFileList = [...(this.form.files[fileIndex].files || [])];
      this.fileListDialogVisible = true;
    },

    // 重新计算文件大小
    recalculateFileSize(fileIndex) {
      if (
        this.form.files[fileIndex] &&
        this.form.files[fileIndex].files &&
        this.form.files[fileIndex].files.length > 0
      ) {
        const totalSize = this.form.files[fileIndex].files.reduce((sum, file) => {
          if (typeof file === "string") {
            return sum;
          } else if (file && file.size) {
            return sum + file.size;
          }
          return sum;
        }, 0);
        this.form.files[fileIndex].totalSize = totalSize;
      } else {
        this.form.files[fileIndex].totalSize = 0;
      }
    },

    // 上传文件
    handleUploadFile(index) {
      this.currentFileIndex = index;
      this.currentFiles = [];
      this.uploadDialogVisible = true;
    },

    // 上传前处理
    handleBeforeUpload(file) {
      const isValidType = ["video/mp4", "application/pdf", "image/jpeg", "image/png"].includes(
        file.type
      );
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isValidType) {
        this.$message.error("只能上传视频、PDF、图片格式的文件!");
        return false;
      }
      if (!isLt100M) {
        this.$message.error("文件大小不能超过100MB!");
        return false;
      }
      return true;
    },

    // 确认上传
    handleUploadConfirm() {
      if (!this.currentFiles || this.currentFiles.length === 0) {
        this.$message.warning("请先上传文件");
        return;
      }

      // 只添加成功上传的文件
      const successFiles = this.currentFiles.filter(
        (file) => file.status === "success" || !file.status
      );

      if (successFiles.length === 0) {
        this.$message.warning("没有成功上传的文件");
        return;
      }

      if (!this.form.files[this.currentFileIndex].files) {
        this.$set(this.form.files[this.currentFileIndex], "files", []);
      }

      // 添加文件对象（保留name, url, size等信息）
      this.form.files[this.currentFileIndex].files.push(...successFiles);
      // 重新计算文件大小
      this.recalculateFileSize(this.currentFileIndex);
      this.uploadDialogVisible = false;
      this.$message.success(`成功添加 ${successFiles.length} 个文件`);
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField("files");
      });
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            await saveTrainingMaterials(this.form);
            this.$emit("confirm", this.form);
            this.handleClose();
          } catch (error) {
            this.$message.error("保存失败");
            console.error(error);
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },

    // 格式化文件大小
    formatSize(size) {
      if (!size || size <= 0) return "";
      const units = ["B", "KB", "MB", "GB", "TB"];
      let idx = 0;
      let val = size;
      while (val >= 1024 && idx < units.length - 1) {
        val = val / 1024;
        idx++;
      }
      return `${val.toFixed(idx === 0 ? 0 : 2)} ${units[idx]}`;
    },

    // 预览文件
    previewFile(url) {
      if (!url) return;
      this.previewUrl = url;
      this.previewDialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.file-upload-section {
  .file-list {
    margin-top: 16px;

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      margin-bottom: 8px;

      .file-info {
        display: flex;
        align-items: flex-start;
        flex: 1;
        flex-direction: row;
      }

      .file-actions {
        margin-left: 16px;

        .el-button {
          margin-left: 8px;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
